import {FC} from "react"
import {Block} from "./Block"
import {CoursePageProps} from "./CoursePageProps"

export const OvercomingFearAndAnxiety: FC<Pick<CoursePageProps, "course">> = () => {
  return (
    <Block>
      <h1 className="mt-16">Welcome to the Overcoming Fear and Anxiety Program.</h1>
      <p>The main goal of this program is to provide exercises, meditations,
        and life hacks that reduce anxiety and fears in the future.
      </p>

      <p>During this course, we will begin with a theoretical component that explores
        the physiological, neurobiological, and evolutionary foundations of anxiety
        and fear. We will differentiate between adaptive and maladaptive
        anxiety and fear and provide strategies to help individuals manage these emotions.
      </p>

      <p>Since there is a two-way relationship between anxiety and bodily tension,
        we will also teach relaxation techniques that involve body and breathing exercises.
      </p>

      <p>As with all our courses, we will also work on identifying and addressing the
        root causes and internal voices that contribute to anxiety and fear. This will
        help individuals identify and overcome the underlying issues that may
        trigger or exacerbate symptoms.
      </p>

      <p>We believe that this program can help you in your journey towards healing and
        recovery from anxiety and fear. We are here to support
        and guide you every step of the way.
      </p>
    </Block>
  )
}
